import { createSlice } from "@reduxjs/toolkit";
import { addProductAPI } from "../../services/addProduct";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const addProductSlice = createSlice({
  name: "addProductDetails",
  initialState: data,
  reducers: {
    addProductSliceInfo(state) {
      state.isLoading = true;
      state.statusCode = undefined;
    },
    addProductSliceInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    addProductSliceInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    addProductSliceInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const addProductHandler =
  (data, options = {}) =>
  async (dispatch) => {
    try {
      dispatch(addProductAction.addProductSliceInfo());
      const response = await addProductAPI(data, options);
      dispatch(addProductAction.addProductSliceInfoSuccess(response));
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(addProductAction.addProductSliceInfoFailure(failurePayload));
    }
  };
export default addProductSlice.reducer;
export const addProductAction = addProductSlice.actions;
